import { useState, useContext, useEffect } from "react"
import { TablePage, CSkeletonTable, TablePagination, ModalDelete, CheckPermission, toast } from "../../../components/widget"
import { ContextNav, ContextLoading, ContextDashboard } from "../../../context";
import { SchedulesApi, DeleteSchedulesApi } from "../../../api";
import { converDurationToMin } from "../../../utils";
import { Link } from "react-router-dom";

export const Schedules = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [searchValue, setSearchValue] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const [tableDataKeeper, setTableDataKeeper] = useState<any>([])
    const col: any = [
        {
            title: "ساعت کاری ",
            render: (i: any) => (
                <div className="min-w-[100px] flex flex-col items-center justify-center w-full text-center relative">
                    <span className="absolute right-1 top-0 text-[11px]">{i.description && i.description != null && i.description}</span>
                    <svg x="0px" y="0px" viewBox="0 0 446 446" className={`mt-[20px]  w-[20px] fill-gray-400 `}>
                        <use xlinkHref="/assetes/svg/clock.svg#clock" />
                    </svg>
                    <span className="mt-1">{i.start_time && i.start_time != null && i.start_time}</span>
                    <span>الی</span>
                    <span>{i.end_time && i.end_time != null && i.end_time}</span>

                </div>)
        },
        {
            title: "گروه شغلی",
            render: (i: any) => (
                <div className="min-w-[100px] flex flex-col items-center justify-center w-full text-center">
                    <svg x="0px" y="0px" viewBox="0 0 279 279" className={` mt-[20px] w-[20px] fill-gray-400 `}>
                        <use xlinkHref="/assetes/svg/bag.svg#bag" />
                    </svg>
                    <span className="mt-1">{i.job_group && i.job_group != null && i.job_group?.name}</span>

                </div>)
        },
        {
            title: "بازه زمانی",
            render: (i: any) => (
                <div className="min-w-[100px] flex flex-col items-center justify-center w-full text-center">
                    <svg x="0px" y="0px" viewBox="0 0 446 446" className={`mt-[20px]  w-[20px] fill-gray-400 `}>
                        <use xlinkHref="/assetes/svg/clock.svg#clock" />
                    </svg>
                    <span className="mt-1">{i.start_datetime && i.start_datetime != null && new Date(i.start_datetime).toLocaleDateString('fa-Ir')}</span>
                    <span>الی</span>
                    <span>{i.end_datetime && i.end_datetime != null && new Date(i.end_datetime).toLocaleDateString('fa-Ir')}</span>
                </div>)
        },
        {
            title: "بازه زمانی شناور",
            render: (i: any) => (
                <>
                    {i.allowed_lateness_on_arrival != 0 &&
                        <div className="min-w-[100px] flex flex-col items-center justify-center w-full text-center">
                            <svg x="0px" y="0px" viewBox="0 0 24 24" className={`  w-[20px] fill-gray-400 `}>
                                <use xlinkHref="/assetes/svg/calender.svg#calender" />
                            </svg>
                            <span className="mt-1">{i.allowed_lateness_on_arrival && i.allowed_lateness_on_arrival != null && converDurationToMin(i.allowed_lateness_on_arrival)} <span className="text-[10px]">(ورود)</span></span>
                            <span>{i.allowed_lateness_on_exit && i.allowed_lateness_on_exit != null && converDurationToMin(i.allowed_lateness_on_exit)} <span className="text-[10px]">(خروج)</span></span>
                        </div>
                    }
                </>
            )
        },
        {
            title: "بازه زمانی اضافه کاری",
            render: (i: any) => (
                <>
                    {i.flexible == 0 ?
                        <>
                            {i.allowed_rushing_on_arrival != 0 &&
                                <div className="min-w-[100px] flex flex-col items-center justify-center w-full text-center">
                                    <svg x="0px" y="0px" viewBox="0 0 470 470" className={`  w-[20px] fill-gray-400 `}>
                                        <use xlinkHref="/assetes/svg/clock2.svg#clock2" />
                                    </svg>
                                    <span className="mt-1">{i.allowed_rushing_on_arrival && i.allowed_rushing_on_arrival != null && converDurationToMin(i.allowed_rushing_on_arrival)} <span className="text-[10px]">(قبل از شیفت)</span></span>
                                    <span>{i.allowed_rushing_on_exit && i.allowed_rushing_on_exit != null && converDurationToMin(i.allowed_rushing_on_exit)} <span className="text-[10px]">(بعد از شیفت)</span></span>
                                </div>
                            }
                        </>
                        :
                        <>
                            {i.allowed_rushing_on_arrival != 0 &&
                                <div className="min-w-[100px] flex flex-col items-center justify-center w-full text-center">

                                    <span className="mt-1">{i.allowed_rushing_on_arrival && i.allowed_rushing_on_arrival != null && converDurationToMin(i.allowed_rushing_on_arrival)} <span className="text-[10px]"></span></span>
                                </div>
                            }
                        </>
                    }
                </>
            )
        },
        {
            title: "الگو تکراری",
            render: (i: any) => (
                <div className="flex flex-col items-center  w-full">
                    <svg x="0px" y="0px" viewBox="0 0 511.979 511.979" className={`  w-[20px] fill-gray-400 `}>
                        <use xlinkHref="/assetes/svg/repeat.svg#repeat" />
                    </svg>
                    <div className=" w-[90%] mt-2 flex justify-center items-center w-6/12 flex-wrap">
                        {i.repeat['0'] != undefined && <div className="m-1 flex items-center justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px]">یکشنبه</div>}
                        {i.repeat['1'] != undefined && <div className="m-1 flex items-center justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px]">دوشنبه</div>}
                        {i.repeat['2'] != undefined && <div className="m-1 flex items-center justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px]">سه شنبه</div>}
                        {i.repeat['3'] != undefined && <div className="m-1 flex items-center justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px]">چهارشنبه</div>}
                        {i.repeat['4'] != undefined && <div className="m-1 flex items-center justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px]">پنجشنبه</div>}
                        {i.repeat['5'] != undefined && <div className="m-1 flex items-center justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px]">جمعه</div>}
                        {i.repeat['6'] != undefined && <div className="mx-1 flex items-center justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px]">شنبه</div>}
                    </div>
                </div>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="w-[80px] flex items-center w-full justify-around">
                    {CheckPermission(53) &&
                        <Link to={`/p/settings/schedules/${i.id}`}>
                            <img src="/assetes/svg/edit.svg" className="w-[20px]  cursor-pointer" />
                        </Link>
                    }
                    {CheckPermission(54) &&
                        <img src="/assetes/svg/trash.svg" onClick={() => startDelete(`${i.id}?group=${i.group}`)} className="w-[20px] cursor-pointer" />
                    }
                </div>)
        },
    ]

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteUser = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteSchedulesApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData()
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }


    const handelSearch = (value: any) => {
        setTableData(
            tableDataKeeper.filter((value1: any) => {
                return !!(value1.description.toUpperCase().includes(value.toUpperCase()));
            })
        )
    }

    const getData = async () => {
        CtxLoad.setDisplayLoadingSkelton(true)
        let res = await SchedulesApi()
        if (res.success) {
            setTableData(res.data)
            setTableDataKeeper(res.data)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        else {
            CtxLoad.setDisplayLoadingSkelton(false)
        }

    }

    useEffect(() => {
        document.title = "شیفت کاری | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 3, })
        getData()
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">مدیریت شیفت‌های کاری</h1>

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <div className="w-full md:w-fit flex items-center">
                    <div className=" max-w-full md:w-[370px] w-full pl-2 overflow-hidden flex items-center bg-white md:mb-0 mb-2 h-[35px] md:h-[50px] rounded-md border-0 shadow">
                        <input onChange={(e: any) => handelSearch(e.target.value)} type={'text'} placeholder="جستجو شیفت کاری" className=" w-[calc(100%-30px)] h-full text-sm px-3 focus:outline-none" />
                        <div className=" w-[30px] h-[30px]  flex justify-center items-center">
                            <svg x="0px" y="0px" viewBox="0 0 487.95 487.95" className={`  w-[25px] fill-[#b9b2b2] `}>
                                <use xlinkHref="/assetes/svg/search.svg#search" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    {CheckPermission(52) ?
                        <button className=" w-full md:w-fit px-[20px] h-[35px] md:h-[50px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                            <Link to='/p/settings/schedules/add' className=" w-full h-full flex justify-center items-center">
                                + افزودن شیفت کاری
                            </Link>
                        </button>
                        :
                        <div />
                    }
                </div>
            </div>

            {CheckPermission(51) &&
                <div className=" w-full ">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} />
                        :
                        <CSkeletonTable />
                    }
                </div>
            }

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteUser} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
